import { Box, Stack } from "@mui/system";
import { spacing } from "../../../../../../../../../../assets/styles/tokens";
import NoPlayerCard from "./NoPlayerCard";

// ─── Mock helper functions (replace with your actual imports) ─────────────────
const formatCurrency = (value: number): string => {
  if (value == null || isNaN(value)) return "$0";
  return "$" + Math.round(value).toLocaleString("en-US");
};

const formatPercent = (value: number): string => {
  if (value == null || isNaN(value)) return "0%";
  return Math.round(value * 100) + "%";
};
// ─────────────────────────────────────────────────────────────────────────────

// ─── Static demo data (replaces sortedData from API) ─────────────────────────
const staticData = [
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    total_income_dollar: 2,
    cpa_income_dollar: 29116,
    rs_income_dollar: 6689,
    rs_perc_from_total_income: 0.38,
    reg: 515,
    click_out: 1751,
    ftd: 234,
    ftd_status: "success",
    ftd_percentage: 21.47,
    ftd_incent_status: "error",
    ftd_incent_percentage: 21.47,
    qftd: 324,
    qftd_status: "error",
    qftd_percentage: 51.47,
    qftd_incent_status: "warning",
    qftd_incent_percentage: 7.47,
    total_income_: 103509,
    roi: 53438,
    net_rev: 37357,
    pv: 145680,
    epc: 42711,
    epc_cpa: 1174,
    cpa_pv: "Brand policy example",
    cpa_pv_qftd: 3890,
    total_income_Percentage: 0.3,
    brand_action_date:"21/04/26"
  },
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    total_income_dollar: 4,
    cpa_income_dollar: 29116,
    rs_income_dollar: 6689,
    rs_perc_from_total_income: 0.3,
    reg: 515,
    click_out: 1751,
    ftd: 456,
    ftd_status: "success",
    ftd_percentage: 35.5,
    ftd_incent_status: "error",
    ftd_incent_percentage: 30.47,
    qftd: 543,
    qftd_status: "error",
    qftd_percentage: 59.47,
    qftd_incent_status: "warning",
    qftd_incent_percentage: 7.47,
    total_income_: 103509,
    roi: 53438,
    net_rev: 37357,
    pv: 145680,
    epc: 42711,
    epc_cpa: 1174,
    cpa_pv: "Brand policy example",
    cpa_pv_qftd: 3890,
    total_income_Percentage: 0.3,
    brand_action_date:"21/04/26"
  },
];
// ─────────────────────────────────────────────────────────────────────────────

const NoPlayerItem = ({ sortedData = staticData }: { sortedData?: any[] }) => {
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <NoPlayerCard
              key={index}
              website_name={item.website_name}
              website_id={item.website_id}
              brand_action_date={item.brand_action_date}
              totalIncome={item.total_income_dollar}
              cpa={formatCurrency(item.cpa_income_dollar)}
              cpaPercentage={formatPercent(
                item.cpa_income_dollar / item.total_income_dollar,
              )}
              cpaColor="success"
              rs={formatCurrency(item.rs_income_dollar)}
              rsPercentage={formatPercent(item.rs_perc_from_total_income)}
              rsColor="error"
              reg={item.reg}
              click_out={item.click_out}
              ftd={item.ftd}
              ftd_status={item.ftd_status}
              ftd_percentage={formatPercent(item.ftd_percentage)}
              qftd={item.qftd}
              qftd_status={item.qftd_status}
              qftd_percentage={formatPercent(item.qftd_percentage)}
              ftd_incent_status={item.ftd_incent_status}
              ftd_incent_percentage={formatPercent(item.ftd_incent_percentage)}
              qftd_incent_status={item.qftd_incent_status}
              qftd_incent_percentage={formatPercent(
                item.qftd_incent_percentage,
              )}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default NoPlayerItem;
